// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"logo_logoContainer__1VHri","iconLogo":"logo_iconLogo__3g2QI"};